export default "__VITE_ASSET__013ecb7b__"